/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { Icon } from '@iconify/react'
import { addTeamsMemberAction } from 'src/reducers/teams/action'
import { componentBoxHideAction } from 'src/reducers/component-box/action'
import { getCollectionSettingsAction } from 'src/reducers/collection/action'
import { useParams } from 'react-router-dom'
import { UserListWithError } from 'src/pages/collection/components/collection-page-view/components/learners/components/teams-member-list/components/import-bulk-member/components'
import {
  CoreButton,
  CoreIconButton,
  CoreTextField,
  CoreFormLayout,
} from 'src/components/core'
import { useSelector } from 'react-redux'
const AddMember = props => {
  const { dispatch, classes } = props
  const { id } = useParams()
  const collection = useSelector(state => state.collection.collection)
  useEffect(() => {
    dispatch(getCollectionSettingsAction(collection.id))
  }, [id])

  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )
  const teams = collectionSettings.teams
  const defaultTeam = teams.find(team => team.default === true)

  const [userListWithError, setUserListWithError] = React.useState([])
  const [responseArrived, setResponseArrived] = React.useState(false)

  const [teamMembers, setTeamMembers] = React.useState([
    {
      name: '',
      username: '',
      email: '',
    },
  ])
  const handleCreateMembers = () => {
    dispatch(
      addTeamsMemberAction(defaultTeam.id, teamMembers, response => {
        setResponseArrived(true)
        let userListWithErrorList = []
        response.map(item => {
          if (item.errors != null) {
            userListWithErrorList = [item, ...userListWithErrorList]
          }
        })
        userListWithErrorList.length == 0 && dispatch(componentBoxHideAction())
        setUserListWithError(userListWithErrorList)
      }),
    )
  }

  const handleDeleteMember = index => {
    const newTeamMembers = [...teamMembers]
    newTeamMembers.splice(index, 1)
    newTeamMembers.length === 0 &&
      newTeamMembers.push({
        name: '',
        username: '',
        email: '',
      })

    setTeamMembers(newTeamMembers)
  }
  const addUserToList = () => {
    const newMember = {
      name: '',
      username: '',
      email: '',
    }
    setTeamMembers([...teamMembers, newMember])
  }
  const handleAddedMember = (e, index) => {
    const { name, value } = e.target
    let newMember = {
      ...teamMembers[index],
      [name]: value,
    }
    if (name === 'email') {
      newMember = {
        ...newMember,
        username: value,
      }
    }
    const newTeamMembers = [...teamMembers]
    newTeamMembers[index] = newMember
    setTeamMembers(newTeamMembers)
  }

  return (
    <div className={classes.modal}>
      <div className={classes.modalContent}>
        <div className={classes.modalContent__header}>
          <Typography className={classes.modalContent__header__title}>
            Create Learner
          </Typography>
        </div>

        {responseArrived
          ? userListWithError && (
              <>
                <Typography
                  className={classes.modalContent__header__description}
                >
                  {teamMembers.length - userListWithError.length} of the{' '}
                  {teamMembers.length} learners have been successfully added to
                  the group.
                </Typography>
                {userListWithError.length > 0 && (
                  <UserListWithError
                    userListWithError={userListWithError}
                  ></UserListWithError>
                )}
              </>
            )
          : teamMembers.length > 0 &&
            teamMembers.map((member, index) => {
              return (
                <div
                  key={index}
                  className={classes.modalContent__header__naming}
                >
                  <CoreFormLayout
                    flexDirection="row"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                    itemGap="8px"
                    itemsPerRow={2}
                  >
                    <CoreTextField
                      value={member.name}
                      onChange={e => handleAddedMember(e, index)}
                      label="Name"
                      name="name"
                      fullWidth
                    />
                    <CoreTextField
                      value={member.email}
                      onChange={e => handleAddedMember(e, index)}
                      label="Email"
                      name="email"
                      fullWidth
                    />
                  </CoreFormLayout>
                  <CoreIconButton
                    onClick={() => handleDeleteMember(index)}
                    color="dark"
                    variant="text"
                    size="large"
                  >
                    <Icon icon="ic:round-close" />{' '}
                  </CoreIconButton>
                </div>
              )
            })}
        {!responseArrived ? (
          <>
            <div>
              <CoreButton
                onClick={() => addUserToList()}
                variant="text"
                size="medium"
                color="disabled"
              >
                + Add Learner
              </CoreButton>
            </div>
            <div className={classes.modalContent__buttons}>
              <CoreButton
                variant="text"
                size="medium"
                color="secondary"
                onClick={() => dispatch(componentBoxHideAction())}
              >
                Cancel
              </CoreButton>
              <CoreButton
                variant="contained"
                size="medium"
                color="success"
                onClick={() => handleCreateMembers()}
              >
                <Typography className={classes.modalContent__buttonText}>
                  Create Learner
                </Typography>
              </CoreButton>
            </div>
          </>
        ) : (
          <>
            <div className={classes.modalContent__buttons}>
              <CoreButton
                variant="contained"
                size="medium"
                color="primary"
                onClick={() => dispatch(componentBoxHideAction())}
              >
                Done
              </CoreButton>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
export default withStyles(styles)(AddMember)
